import { useFormContext } from "react-hook-form";

import check from "./check.png";

function NotificationsModal({ _notificationCurrent, savePrefrenceCallback, setHomeData }) {
  const { register, setValue, watch } = useFormContext();

  const pinned_case_activity = watch("pinned_case_activity");

  return (
    <>
      <div className="radio-container">
        <div className="d-flex height-35  align-items-center justify-content-center">
          <div
            className="notification-toggle height-35 "
            style={{
              width: "430px",
            }}
          >
            <span>Notifications For Pinned Case Activity On Home Page</span>
            <div
              className={`checkbox-container ${pinned_case_activity ? "checked" : ""}`}
              // onClick={() =>
              //   setValue("pinned_case_activity", !pinned_case_activity)
              // }
              onClick={() => {
                setValue("pinned_case_activity", !pinned_case_activity);
                const updated = {
                  ...watch(),
                  pinned_case_activity: !pinned_case_activity,
                };
                savePrefrenceCallback(updated);
                setHomeData(updated);
              }}
            >
              <input
                type="checkbox"
                {...register("pinned_case_activity")}
                className="checkbox-input"
              />
              {pinned_case_activity && (
                <span className="check-icon" style={{ height: "15px", width: "15px" }}>
                  <img src={check} alt="check" />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotificationsModal;
